import {API_V1_URL} from "../../constants/other"
import http from "../../http"

const PRODUCTS_URL = `${API_V1_URL}/products/`

export const getProductById = (productId) => http.get(`${PRODUCTS_URL}${productId}`)